module.exports = __webpack_public_path__ + "img/worker-1.a7751805.png";